module.exports = __webpack_public_path__ + "static/media/grocery-cooking-ess-bg.4ff28a3e.png";